<template>
  <div class="Page">
    <div class="Page-Content" style="overflow: hidden">
      <swiper
        class="swiper swiperInformation"
        :options="swiperOption"
        ref="swiperOption"
      >
        <swiper-slide>
          <div style="position: relative">
            <h1
              style="position: absolute; top: 20px; left: 20px;z-index: 999;"
              class="ani font-Larken"
              swiper-animate-effect="fadeInLeft"
              swiper-animate-duration="1.5s"
            >
              Design by Nature <br />
              Where Life Flows
            </h1>
            <div class="image-container">
              <img src="@/assets/home/home.png" alt="" />
            </div>

          </div>
        </swiper-slide>
        <swiper-slide
          class="slide-div"
          :style="`background-image: url(${bg1});width: 100%;height: 100%;background-size: 100% 100%;`"
        >
          <div style="color: white">
            <h1
              class="ani font-Larken"
              swiper-animate-effect="fadeInUp"
              swiper-animate-duration="1.5s"
            >
              Designed by Nature,<br />
              Where Life Flows
            </h1>
            <p
              class="ani  font-acuminpro"
              swiper-animate-effect="fadeInUp"
              swiper-animate-duration="1.5s"
            >
              Dreams are the touchstones of our character. When we dream of
              nature’s beauty, <br />
              we paint it with the colours of our soul, and through our actions,
              we can bring that <br />
              masterpiece to life.
            </p>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div style="flex: 1">
            <h1 class="ani font-Larken" swiper-animate-effect="fadeInUp">
              Commune with Nature and <br />
              Discover the Richness of Life
            </h1>
            <img style="width: 50%" src="@/assets/home/home5.png" alt="" />
            <p
              class="min-font-size ani font-acuminpro"
              swiper-animate-effect="fadeInUp"
              swiper-animate-duration="1.5s"
            >
              On a hill, in nature, by the tranquil waters, an idyllic life
              awaits. This is a <br />
              haven where life flows with colour – a place for families to grow,
              connect, <br />
              and celebrate life’s richness.
            </p>
          </div>
          <div class="image-container" :style="`background-image: url(${bg2});width: 100%;height: 100%;background-size: cover;flex:1;`"></div>
        </swiper-slide>
        <swiper-slide
          :style="`background-image: url(${bg3});width: 100%;height: 100%;background-size: 100% 100%;`"
        >
          <div class="ani" swiper-animate-effect="fadeInUp" style="flex: 1">
            <h1 class="ani font-Larken" swiper-animate-effect="fadeInUp">
              Nothing makes me so happy <br />
              as to observe nature and to <br />
              paint what I see.
            </h1>
            <p>– Henri Rousseau</p>
          </div>
          <div style="flex: 1">
            <p class="ani" swiper-animate-effect="fadeInRight">01</p>
            <h1 class="ani font-Larken" swiper-animate-effect="fadeInRight">Nature</h1>
            <img style="width: 50%" src="@/assets/home/home7.png" alt="" />
            <p
              class="min-font-size ani"
              swiper-animate-effect="fadeInRight"
              swiper-animate-duration="1.5s"
            >
              Nestled in the prestigious Mount Sinai and Pandan Valley estates,
              <br />
              Nava Grove sits within Singapore’s verdant green belt,
              neighbouring the <br />
              Good Class Bungalows enclaves, perched on elevated grounds.
            </p>
            <p
              class="min-font-size ani"
              swiper-animate-effect="fadeInRight"
              swiper-animate-duration="1.5s"
            >
              Lush, picturesque, and almost untouched, the richness of nature
              flows all <br />
              around – from the Clementi and Dover Forests, to the Rail Corridor
              and <br />
              Ulu Pandan Park Connector, to the Greater Southern Waterfront and
              beyond.
            </p>
          </div>
        </swiper-slide>
        <swiper-slide
          :style="`background-image: url(${bg4});width: 100%;height: 100%;background-size: 100% 100%;`"
        >
          <div class="ani" swiper-animate-effect="fadeInUp" style="flex: 1">
            <h1 class="ani font-Larken" swiper-animate-effect="fadeInUp">
              The sound of water is <br />
              worth more than all the <br />
              poets’ words.
            </h1>
            <p>– Octavio Paz</p>
          </div>
          <div style="flex: 1">
            <p class="ani" swiper-animate-effect="fadeInRight">02</p>
            <h1 class="ani font-Larken" swiper-animate-effect="fadeInRight">Nurture</h1>
            <img style="width: 50%" src="@/assets/home/home10.png" alt="" />
            <p
              class="min-font-size ani"
              swiper-animate-effect="fadeInRight"
              swiper-animate-duration="1.5s"
            >
            A wondrous world of water beckons you at Nava Grove, with breathtaking pools <br />
and gently meandering streams reflecting the soft morning light, all wrapped in <br />
ribbons of green.
            </p>

          </div>
        </swiper-slide>
        <!-- <swiper-slide
          style="
            background-color: #dcecf3;
            width: 100%;
            height: 100%;
            background-size: 100% 100%;
          "
        >
          <div style="width: 90%; height: 90%" class="flex-start">
            <h2
              style="text-align: start"
              class="ani font-Larken"
              swiper-animate-effect="fadeInRight"
              swiper-animate-duration="1.5s"
            >
              Come Home <br />
              to Nature
            </h2>
            <p
              style="text-align: start"
              class="ani min-font-size"
              swiper-animate-effect="fadeInRight"
              swiper-animate-duration="1.5s"
            >
              Embrace a sense of peace and tranquillity as you arrive <br />
              home to Nava Grove. Be greeted by a grand Arrival Plaza, <br />
              where cascading waters and majestic rain trees set the <br />
              stage for a luxurious and calming welcome.
            </p>
            <img src="@/assets/home/home11.png" alt="" />
          </div>
        </swiper-slide>
        <swiper-slide>
          <img src="@/assets/home/home13.png" alt="" />
        </swiper-slide>
        <swiper-slide
          style="
            background-color: #dcecf3;
            width: 100%;
            height: 100%;
            background-size: 100% 100%;
          "
        >
          <div style="width: 90%; height: 90%" class="flex-start">
            <h2
              style="text-align: start"
              class="ani font-Larken"
              swiper-animate-effect="fadeInRight"
              swiper-animate-duration="1.5s"
            >
              Resplendent Views <br />
              of Green
            </h2>
            <p
              style="text-align: start"
              class="ani min-font-size"
              swiper-animate-effect="fadeInRight"
              swiper-animate-duration="1.5s"
            >
              From the sprawling grounds, pavilions look out to an <br />
              endless sea of green. Within the development, you’ll find <br />
              serene landscapes and a host of facilities that everyone <br />
              can enjoy. Here, nature’s beauty and idyllic spaces blend <br />
              seamlessly, crafting a sanctuary of relaxation.
            </p>
            <img src="@/assets/home/home14.png" alt="" />
          </div>
        </swiper-slide>
        <swiper-slide
          style="
            background-color: #dcecf3;
            width: 100%;
            height: 100%;
            background-size: 100% 100%;
          "
        >
          <div style="width: 90%; height: 90%" class="flex-start">
            <h2
              style="text-align: start"
              class="ani font-Larken"
              swiper-animate-effect="fadeInRight"
              swiper-animate-duration="1.5s"
            >
              Be Truly Immersed <br />
              in Nature
            </h2>
            <p
              style="text-align: start"
              class="ani min-font-size"
              swiper-animate-effect="fadeInRight"
              swiper-animate-duration="1.5s"
            >
              The flowing landscape embraces the natural contours, <br />
              beautifully framing generous recreational spaces. Nestled <br />
              within this lush greenery is Forest Dining, where a private <br />
              second-floor dining area, complete with a full-fledged <br />
              kitchen and media room, offers a perfect setting for <br />
              hosting and entertainment.
            </p>
            <div
              style="
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                width: 100%;
              "
            >
              <img style="width: 82%" src="@/assets/home/home18.png" alt="" />
              <div style="width: 16%">
                <p
                  class="min-font-size ani"
                  swiper-animate-effect="fadeInRight"
                  swiper-animate-duration="1.5s"
                >
                  The landscape design utilises Nava Grove’s <br />
                  natural contours to bring you up close and <br />
                  personal with nature.
                </p>
                <img
                  style="height: auto"
                  src="@/assets/home/home19.png"
                  alt=""
                />
                <img
                  style="height: auto"
                  src="@/assets/home/home16.png"
                  alt=""
                />
                <p
                  class="min-font-size ani"
                  swiper-animate-effect="fadeInRight"
                  swiper-animate-duration="1.5s"
                >
                  Admire the details of majestic conserved trees <br />
                  or simply bask in nature’s grandeur.
                </p>
              </div>
            </div>
          </div>
        </swiper-slide>
        <swiper-slide
          style="
            background-color: #dcecf3;
            width: 100%;
            height: 100%;
            background-size: 100% 100%;
          "
        >
          <div
            style="
              width: 90%;
              height: 90%;
              display: flex;
              justify-content: space-between;
              flex-direction: row;
              align-items: flex-start;
            "
          >
            <div style="width: 60%; height: 100%">
              <h2
                style="text-align: start"
                class="ani font-Larken"
                swiper-animate-effect="fadeInRight"
                swiper-animate-duration="1.5s"
              >
                Designed for <br />
                Play and Wellness
              </h2>
              <p
                style="text-align: start"
                class="ani min-font-size"
                swiper-animate-effect="fadeInRight"
                swiper-animate-duration="1.5s"
              >
                At Nava Grove, the soothing presence of water greets <br />
                you at every turn, as streams meander through <br />
                a landscape of flowing tranquillity. Three glistening <br />
                pools – a 50m Lagoon Pool, a Children’s Pool, and <br />
                an Infinity Edge Wellness Pool – are complemented by <br />
                gentle flowing waterways, creating a serene retreat.
              </p>
              <img
                style="height: 75%; object-fit: cover"
                src="@/assets/home/home21.png"
                alt=""
              />
            </div>
            <div
              style="
                width: 40%;
                display: flex;
                flex-direction: column;
                align-items: flex-end;
              "
            >
              <div
                style="
                  width: 75%;
                  display: flex;
                  flex-direction: column;
                  align-items: flex-end;
                "
              >
                <img src="@/assets/home/home22.png" alt="" />
                <p
                  class="min-font-size ani"
                  swiper-animate-effect="fadeInUp"
                  swiper-animate-duration="1.5s"
                  style="text-align: start; width: 100%"
                >
                  Indulge in facilities for fitness and recreation, including a
                  gymnasium, a tennis court, <br />
                  and a versatile multipurpose court ideal for pickleball and
                  other activities.
                </p>
              </div>
              <div style="width: 55%">
                <p
                  class="min-font-size ani"
                  swiper-animate-effect="fadeInUp"
                  swiper-animate-duration="1.5s"
                  style="text-align: start; width: 100%"
                >
                  Bask in the warmth of nature, where expansive greenery invites
                  <br />
                  both relaxation and playful moments. These outdoor open spaces
                  <br />
                  are perfect for pet owners and their pets to enjoy the fresh
                  air <br />
                  and serene surroundings.
                </p>
                <img src="@/assets/home/home23.png" alt="" />
              </div>
            </div>
          </div>
        </swiper-slide>
        <swiper-slide>
          <img src="@/assets/home/home24.png" alt="" />
        </swiper-slide>
        <swiper-slide
          style="
            background-color: #dcecf3;
            width: 100%;
            height: 100%;
            background-size: 100% 100%;
          "
        >
          <div style="width: 90%; height: 90%" class="flex-start">
            <h2
              style="text-align: start"
              class="ani font-Larken"
              swiper-animate-effect="fadeInRight"
              swiper-animate-duration="1.5s"
            >
            Let Nature Play Host
            </h2>
            <p
              style="text-align: start"
              class="ani min-font-size"
              swiper-animate-effect="fadeInRight"
              swiper-animate-duration="1.5s"
            >
            As the sun sets, the Dining Cabana offers mesmerising <br />
views of the flowing lagoon and beautiful trees. Immerse <br />
yourself in the enchanting ambience while you let nature <br />
play host, surrounded by the cherished company of <br />
friends and family
            </p>
            <div
              style="
                display: flex;
                flex-direction: row;
                align-items: flex-end;
                justify-content: space-between;
                width: 100%;
              "
            >
              <img style="width: 82%" src="@/assets/home/home26.png" alt="" />
              <div style="width: 16%">
                <p
                  class="min-font-size ani"
                  swiper-animate-effect="fadeInUp"
                  swiper-animate-duration="1.5s"
                >
                  The landscape design utilises Nava Grove’s <br />
                  natural contours to bring you up close and <br />
                  personal with nature.
                </p>
                <img
                  style="height: auto"
                  src="@/assets/home/home27.png"
                  alt=""
                />
              </div>
            </div>
          </div>
        </swiper-slide>
        <swiper-slide>
          <img src="@/assets/home/home28.png" alt="" />
        </swiper-slide>
        <swiper-slide>
          <div style="position: relative">
            <h4
              style="position: absolute; top: 40%; right: 10%"
              class="ani font-Larken"
              swiper-animate-effect="fadeInLeft"
              swiper-animate-duration="1.5s"
            >
            When Nature is at the Heart, <br />
            We Return to the Heart of Life
            </h4>
            <img src="@/assets/home/home29.png" alt="" />
          </div>
        </swiper-slide> -->
        <swiper-slide
          :style="`background-image: url(${bg3});width: 100%;height: 100%;background-size: 100% 100%;`"
        >
          <div class="ani" swiper-animate-effect="fadeInUp" style="flex: 1">
            <h1 class="ani font-Larken" swiper-animate-effect="fadeInUp">
              The family is one of <br />
              nature’s masterpieces.
            </h1>
            <p>– George Santayana</p>
          </div>
          <div style="flex: 1">
            <p class="ani" swiper-animate-effect="fadeInRight">03</p>
            <h1 class="ani font-Larken" swiper-animate-effect="fadeInRight">Nourish</h1>
            <img style="width: 50%" src="@/assets/home/home31.png" alt="" />
            <p
              class="min-font-size ani"
              swiper-animate-effect="fadeInUp"
              swiper-animate-duration="1.5s"
            >
            At home in nature, you’ll find nourishment for your well-being and also <br />
build bonds with your loved ones. This is where life flourishes with vitality <br />
and harmony. A retreat from the everyday, where every moment becomes <br />
a memory, and every space invites renewal.
            </p>
          </div>
        </swiper-slide>
      </swiper>

      <div class="swiper-button-prev" style="left: 5%; top: 45%">
        <img src="@/assets/btn/left1.png" alt="" />
      </div>
      <div class="swiper-button-next" style="right: 5%; top: 45%">
        <img src="@/assets/btn/right1.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import {
  swiperAnimateCache,
  swiperAnimate,
  clearSwiperAnimate,
} from "@/assets/swiper.animate1.0.3.min.js";

export default {
  data() {
    return {
      bg1: require("@/assets/home/home1.png"),
      bg2: require("@/assets/home/home6.png"),
      bg3: require("@/assets/home/home8.png"),
      bg4: require("@/assets/home/home9.png"),
      swiperOption: {
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        slidesPerView: 1,
        loopedSlides: 0, // looped slides should be the same
        // spaceBetween: 10,
        centeredSlides: true,
        loop:true,
        // autoplay: {
        //     delay: 5000, // 轮播间隔时间，单位为毫秒
        //     disableOnInteraction: false, // 用户操作后是否禁止自动轮播
        //   },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        on: {
          init: function () {
            swiperAnimateCache(this); //隐藏动画元素
            swiperAnimate(this); //初始化完成开始动画
          },
          slideChangeTransitionEnd: function () {
            swiperAnimate(this); //每个slide切换结束时也运行当前slide动画
            //this.slides.eq(this.activeIndex).find('.ani').removeClass('ani'); 动画只展现一次，去除ani类名
          },
        },
      },

    };
  },
  methods: {
    padZero(num, length) {
      return String(num).padStart(length, "0");
    },
  },
  mounted() {},
};
</script>

<style lang="less" scoped>

.image-container{
  position: relative;
}
.image-container::before{
  position: absolute;
  right: 10px;
  bottom: 10px;
  font-size: 10px;
  display: block;
  color: white;
  content: "Artist’s Impression";
}
.image-container img{
  display: block;
}

.flex-start {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
}

.min-font-size {
  font-size: 12px;
}

.swiperInformation {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.151);
  // border-radius: 10px;
  .swiper-slide {
    width: 100%;
    height: 100%;
    overflow-y: auto;
    img {
      object-fit: contain;
      height: 100%;
      width: 100%;
    }
  }
}
.swiper-slide {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  // border-radius: 10px;
  // background-color: #000000;
}
.swiper-button-prev,
.swiper-button-next {
  display: flex;
  justify-content: center;
  align-items: center;
  background: none;
  img {
    max-height: 5rem;
    max-width: 5rem;
  }
}
</style>

